import { Text } from '@usealloy/component-library';
import React from 'react';

interface ActionSectionTitleProps {
  content: string;
}
export default function ActionSectionTitle({
  content,
}: ActionSectionTitleProps) {
  return (
    <Text
      size={3}
      style={{
        marginTop: 'var(--cl-space-10)',
        marginBottom: 'var(--cl-space-2)',
      }}
    >
      {content}
    </Text>
  );
}
